import classNames from 'classnames';
import React, { PureComponent } from 'react';

class FlexLayoutContainer extends PureComponent<any> {
  render() {
    const { className, children } = this.props;

    /*
		In order to have any margins around the whole container NOT interfere with the negative margins of the container, we need to put it on a separate outermost div. The negative margins of the flex container itself ensure that boxes against the edges of the container are flush with the edge.
		*/
    return (
      <div className={classNames({ [className]: !!className })}>
        <div className="flex-layout__flex-container">{children}</div>
      </div>
    );
  }
}

// NOTE: Intended for use as parent of FlexLayoutBox to work properly.

export default FlexLayoutContainer;
